export default __webpack_public_path__ + "static/media/ey_logo.70de41ba.svg";